import { render, staticRenderFns } from "./TypeCodes.vue?vue&type=template&id=f9336e4c"
import script from "./TypeCodes.vue?vue&type=script&lang=js"
export * from "./TypeCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/ffa2b6072150c7f8/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9336e4c')) {
      api.createRecord('f9336e4c', component.options)
    } else {
      api.reload('f9336e4c', component.options)
    }
    module.hot.accept("./TypeCodes.vue?vue&type=template&id=f9336e4c", function () {
      api.rerender('f9336e4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/CrossOrg/TypeCodes.vue"
export default component.exports